import { thumbnailDisplayUrl } from "@/lib/venueImages";
import { useState } from "react";
import { getNameInitial } from "@/lib/memberAvatar";

type ProfileAvatarProps = {
  src?: string | null;
  name?: string | null;
  alt?: string;
  className?: string;
  imgClassName?: string;
  isLight?: boolean;
  fallbackClassName?: string;
  fallbackTextClassName?: string;
};

export function ProfileAvatar({
  src,
  name,
  alt,
  className = "w-10 h-10 rounded-full",
  imgClassName = "object-cover",
  isLight,
  fallbackClassName,
  fallbackTextClassName = "text-sm font-semibold",
}: ProfileAvatarProps) {
  const [imgFailed, setImgFailed] = useState(false);
  const showPhoto = Boolean(src?.trim()) && !imgFailed;
  const initial = getNameInitial(name);
  const label = alt ?? (name ? `${name} avatar` : "Profile avatar");

  const defaultFallback =
    isLight === true
      ? "bg-gradient-to-br from-purple-100 to-pink-100 text-purple-600"
      : "bg-gradient-to-br from-purple-600 to-pink-600 text-white";

  if (showPhoto) {
    return (
      <img
        src={thumbnailDisplayUrl(src!.trim(), 480)}
        alt={label}
        className={`${className} ${imgClassName}`}
        onError={() => setImgFailed(true)}
      />
    );
  }

  return (
    <div
      className={`${className} flex items-center justify-center overflow-hidden ${fallbackClassName ?? defaultFallback}`}
      aria-label={label}
      role="img"
    >
      <span className={fallbackTextClassName}>{initial}</span>
    </div>
  );
}
